module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic-ext29.857026d.woff2";